/* ── SPCore - navigation progress ── */
(function () {
  'use strict';

  var GIVE_UP_MS = 10000;

  var bar = null;
  var fill = null;
  var wash = null;
  var tick = null;
  var bail = null;
  var pct = 0;
  var running = false;

  var CSS = [
    'main#MainContent{position:relative}',
    '.sp-navwash{',
    'position:absolute;inset:0;z-index:2147482999;pointer-events:none;',
    'background:#fff;opacity:0;',
    'transition:opacity .5s ease .16s}',
    '.sp-navwash.is-on{opacity:.62}',
    '.sp-navwash--viewport{position:fixed}',

    '.sp-navbar{',
    'position:fixed;inset-block-start:0;inset-inline:0;z-index:2147483000;',
    'height:3px;pointer-events:none;opacity:0;',
    'transition:opacity .2s ease}',
    '.sp-navbar.is-on{opacity:1}',
    '.sp-navbar__fill{',
    'display:block;width:100%;height:100%;',
    'transform:scaleX(0);transform-origin:0 50%;',
    'background:rgb(var(--c-accent,17 17 17));',
    'transition:transform .2s cubic-bezier(.2,.8,.2,1)}',

    'html.sp-nav-busy,html.sp-nav-busy a,html.sp-nav-busy button{cursor:progress}',

    '@media (prefers-reduced-motion:reduce){',
    '.sp-navbar__fill{transition:none}',
    '.sp-navwash{transition:opacity .01s linear .16s}}'
  ].join('');

  function build() {
    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    var main = document.querySelector('main#MainContent');
    wash = document.createElement('div');
    wash.className = 'sp-navwash' + (main ? '' : ' sp-navwash--viewport');
    wash.setAttribute('aria-hidden', 'true');
    (main || document.body).appendChild(wash);

    bar = document.createElement('div');
    bar.className = 'sp-navbar';
    bar.setAttribute('aria-hidden', 'true');

    fill = document.createElement('span');
    fill.className = 'sp-navbar__fill';
    bar.appendChild(fill);

    document.body.appendChild(bar);
  }

  function paint() {
    fill.style.transform = 'scaleX(' + (pct / 100).toFixed(4) + ')';
  }

  function start() {
    if (running) return;
    running = true;

    if (!bar) build();

    document.documentElement.classList.add('sp-nav-busy');

    pct = 0;
    paint();
    void fill.offsetWidth;

    bar.classList.add('is-on');
    wash.classList.add('is-on');
    pct = 12;
    paint();

    tick = setInterval(function () {
      pct += (90 - pct) * 0.12;
      paint();
    }, 140);

    bail = setTimeout(stop, GIVE_UP_MS);
  }

  function stop() {
    if (!running) return;
    running = false;

    clearInterval(tick);
    clearTimeout(bail);
    tick = bail = null;

    document.documentElement.classList.remove('sp-nav-busy');

    if (!bar) return;
    pct = 100;
    paint();
    bar.classList.remove('is-on');
    wash.classList.remove('is-on');
    setTimeout(function () {
      if (running) return;
      pct = 0;
      paint();
    }, 240);
  }

  /* ── what counts as a navigation ── */

  function leaves(a, e) {
    var customizer = a && (a.id === 'qstomizer-product-button' || (a.pathname || '').indexOf('/apps/qstomizer') === 0);
    if (e.defaultPrevented && !customizer) return false;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
    if (!a || !a.href || a.hasAttribute('download')) return false;
    if (a.target && a.target !== '_self') return false;
    if (a.protocol !== 'http:' && a.protocol !== 'https:') return false;
    if (a.origin !== window.location.origin) return false;

    var raw = a.getAttribute('href') || '';
    if (raw.charAt(0) === '#') return false;

    if (a.pathname === window.location.pathname &&
        a.search === window.location.search &&
        a.hash) return false;

    if (a.closest('[data-sp-no-progress]')) return false;
    return true;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var a = e.target.closest('a[href]');
    if (!a || !leaves(a, e)) return;
    start();
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (e.defaultPrevented || !f || !f.closest) return;
    if (f.target && f.target !== '_self') return;
    if (f.closest('[data-sp-no-progress]')) return;
    start();
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) stop();
  });

  window.SPNav = { start: start, stop: stop };
}());
